import { Models } from "api/types";

export interface Currency {
  code: string;
  decimalDigits: number;
}

const CURRENCIES = {
  USD: { code: "USD", decimalDigits: 2 },
  CAD: { code: "CAD", decimalDigits: 2 },
} as const satisfies Record<string, Currency>;

class CurrencyService {
  private currency: Currency = CURRENCIES.USD;

  public setCurrency(stripeRegion: Models<"StripeRegion"> | undefined): void {
    this.currency = {
      US: CURRENCIES.USD,
      CA: CURRENCIES.CAD,
    }[stripeRegion ?? "US"];
  }

  public getCurrency(): Currency {
    return this.currency;
  }
}

export const currencyService = new CurrencyService();
